export default __webpack_public_path__ + "static/media/Puro.86554144.svg";